import React, { useState } from 'react';
import { IProgressiveLoadingImage } from '../../../interfaces/image/image';
import { getImageAsset } from '../../../helpers/Images';

const ProgressiveLoadingImage = ({ imageUrl, maxWidth, token, altText} : IProgressiveLoadingImage) => {
  const [loaded, setLoaded] = useState(false);
  const lowResUrl = getImageAsset(100, imageUrl, token);
  const highResUrl = getImageAsset(maxWidth, imageUrl, token);

  return (
    <>
    {/* this image will appear with the low res image */}
      <img
        className={`progressive-loading-image-low-res ${loaded && 'is-loaded'}`}
        src={lowResUrl}
        alt={altText || ""}
       />

    {/* this high res image will appear in the place of the other when it has loaded */}
      <img
        className={`progressive-loading-image-high-res ${loaded && 'display-high-res'}`}
        src={highResUrl}
        alt={altText || ""}
        onLoad={() => setLoaded(true)}
      />
    </>
  );
};

export default ProgressiveLoadingImage;